import { render, staticRenderFns } from "./relationship-form.vue?vue&type=template&id=6d4fb80c&"
import script from "./relationship-form.vue?vue&type=script&lang=js&"
export * from "./relationship-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports